/**
 * created by zhouzt on 2020-01-17
 *
 * description: 权限常量
 *
 */

const auths = {
	// 按钮权限
	BTN_AUTH: {
		'审批处理-查看': 'M001045',
		'审批处理-审核': 'M00104500',
		'审批处理-批量审核': 'M00104501',

		'我提交的审批-查看': 'M001047',

		'审批设置-查看': 'M001048',
		'审批设置-新增审批流': 'M00104800',
		'审批设置-修改审批流': 'M00104801',
		'审批设置-停用启用': 'M00104802',
		'审批设置-删除审批流': 'M00104803',
		'审批设置-子节点管理': 'M00104804',
	}
};

export default auths;


// WEBPACK FOOTER //
// ./src/consts/auths/index.js